import { useGetPatientFeatureEntitlementQuery } from '../../services/entitlements/operations.generated';
import { RoomForPatient, UserSubscriptionType } from '../../services';
import { useService } from '../../hooks';
import { FronteggFeatureKeys } from '../../context/userEntitlementsContext.types';
import { getIsGraphqlRoomQueriesEnabled } from '../../utils/isGraphqlRoomQueriesEnabled';

type UsePatientPaidStatusReturn = {
  isPaidUser: boolean;
  roomAdminSubscriptionType: UserSubscriptionType;
  freeOrPaid: 'free' | 'paid';
};

export const usePatientPaidStatus = (
  room?: RoomForPatient | null,
): UsePatientPaidStatusReturn => {
  const isProvider = useService('$context') === 'provider';
  const isGraphqlRoomQueriesEnabled = getIsGraphqlRoomQueriesEnabled();

  const { currentData: patientFeatureEntitlement } =
    useGetPatientFeatureEntitlementQuery(
      {
        input: {
          featureKey: FronteggFeatureKeys.ProPlan,
          roomSlug: room?.slug as string,
        },
      },
      {
        skip: !room?.slug || isGraphqlRoomQueriesEnabled || isProvider,
      },
    );

  if (isProvider) {
    return {
      isPaidUser: false,
      roomAdminSubscriptionType: UserSubscriptionType.Free,
      freeOrPaid: 'free',
    };
  }

  const isPaidUser = isGraphqlRoomQueriesEnabled
    ? room?.owner?.subscriptionType === UserSubscriptionType.Pro
    : Boolean(
        patientFeatureEntitlement?.Entitlements.getPatientFeatureEntitlement
          ?.isEntitled,
      );

  return {
    isPaidUser,
    roomAdminSubscriptionType: isPaidUser
      ? UserSubscriptionType.Pro
      : UserSubscriptionType.Free,
    freeOrPaid: isPaidUser ? 'paid' : 'free',
  };
};
